import nyNetwork from "@/api/nyBaseNetwork";
import DZModelDic from "@/views/字典管理/model/DZModelDic";
import DZModelDicType from "@/views/字典管理/model/DZModelDicType";
import DZModelDicLabel from "@/views/字典管理/model/DZModelDicLabel";
import DZModelPage from "@/model/DZModelPage";


class DZServiceDic {

    list_dic : Array<DZModelDic> = [];

    list_type : Array<DZModelDicType> = [];

    list_label : Array<DZModelDicLabel> = [];

    m_type = new DZModelDicType();

    m_label = new DZModelDicLabel();

    m_dic = new DZModelDic();

    m_page = new DZModelPage(10);

    /** 分类 **/
    net_add_type(success: () => void){
        nyNetwork.net("添加字典分类",this.m_type, data => {
            success()
        })
    }

    net_edit_type(success: () => void){
        nyNetwork.net("修改字典分类",this.m_type, data => {
            success()
        })
    }

    net_page_list_type(m_page){
        nyNetwork.net("字典分类列表",m_page, data => {
            this.list_type = data
        })
    }

    net_delete_type(id,success: () => void){
        nyNetwork.net("删除字典分类",{id:id}, data => {
            success()
        })
    }

    /** 字典 **/
    net_page_list_dic(id,m_page){
        nyNetwork.net("字典分页",{type:id,pageSize:m_page.pageSize,pageNum:m_page.pageNum}, data => {
            this.list_dic = data.list
        })
    }

    net_list_by_type(name){
        nyNetwork.net("字典列表查询",{name:name}, data => {

        })
    }

    net_add_dic(success: () => void){
        nyNetwork.net("添加字典",this.m_dic, data => {
            success()
        })
    }

    net_edit_dic(success: () => void){
        nyNetwork.net("修改字典",this.m_dic, data => {
            success()
        })
    }

    net_del_dic(id,success: () => void){
        nyNetwork.net("删除字典",{id:id}, data => {
            success()
        })
    }

    // 标签 ===============================================================

    net_add_label(success: () => void){
        nyNetwork.net("添加字典标签",this.m_label, res => {
            success()
        })
    }

    net_edit_label(success: () => void){
        nyNetwork.net('修改字典标签',this.m_label,res =>{
            success()
        })
    }

    net_del_label(id,success: () => void){
        nyNetwork.net('删除字典标签',{id:id},res =>{
            success()
        })
    }

    net_page_label(m_page){
        nyNetwork.net('字典标签分页',m_page,res =>{
            this.list_label = res.list
            this.m_page.total = res.total
        })
    }

    net_list_label(){
        nyNetwork.net('字典标签列表',{},res =>{
            this.list_label = res
        })
    }
}
export default DZServiceDic;
